// extracted by mini-css-extract-plugin
export default {"language_edit_input":"LanguageEdit_language_edit_input__gIqM0","language_period_date":"LanguageEdit_language_period_date__5Jhj4"};